export const BRAND = {
  name: "Zilkart",
  tagline: "Built for value, made for everyone",
  headerTagline: "Value finds, happy you",
  phone: "9717198384",
  email: "Care.zilkartindia@gmail.com",
  instagram: "https://www.instagram.com/zilkart?utm_source=qr&stkn=MXFjemR1M3dicXZ3bA==",
  facebook: "https://www.facebook.com/share/1ZjkqdiQ5H/",
  logo: "/zilkart-logo.png",
  icon: "/zilkart-icon.png",
};

export const formatINR = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
